<header role="banner">
  <elapp-nav></elapp-nav>
</header>
